export const environment = {
    production: false,
    xrayUrl: "https://bp-dev-apim.azure-api.net/xray-web-dev/"
};
